import React from "react";
import { Mic, Square } from "lucide-react";

export const MicButton = ({ voice, testid }) => (
  <button type="button" onClick={voice.toggle} data-testid={testid} aria-pressed={voice.listening}
    aria-label={voice.listening ? "Stop voice typing" : "Voice typing"} title={voice.listening ? "Stop voice typing" : "Voice typing"}
    className={`w-9 h-9 rounded-full flex items-center justify-center transition-colors ${voice.listening ? "bg-rose-500 text-white mic-live" : "text-slate-600 hover:bg-slate-100"}`}>
    {voice.listening ? <Square size={13} fill="currentColor" /> : <Mic size={18} strokeWidth={1.8} />}
  </button>
);

export default MicButton;
